const initPointActivity = {
  pointActivities: [],
  currentPage: 1,
  totalPage: 1,
  limitPage: 10,
  lengthPage: 1,
  searchValue: "",
  filterPointTypePage: "",
  poinTypeFilters: [
    { label: "All", value: "all" },
    { label: "Exp Point", value: "exp" },
    { label: "Ancol Point", value: "point" },
  ],
  isFilterLoading: false,
};

export const pointActivityReducer = (
  state = initPointActivity,
  action: any
) => {
  if (action.type === "SET_POINT_ACTIVITY") {
    return {
      ...state,
      pointActivities: action.value,
    };
  }
  if (action.type === "SET_POINT_ACTIVITY_CURRENT_PAGE") {
    return {
      ...state,
      currentPage: action.currentPage,
    };
  }
  if (action.type === "SET_POINT_ACTIVITY_PAGE") {
    return {
      ...state,
      totalPage: action.totalPage,
      limitPage: action.limitPage,
      lengthPage: action.lengthPage,
    };
  }
  if (action.type === "SET_POINT_ACTIVITY_FILTER_PAGE") {
    return {
      ...state,
      filterPointTypePage: action.filterPointTypePage,
    };
  }
  if (action.type === "SET_SEARCH_POINT_ACTIVITY") {
    return {
      ...state,
      searchValue: action.searchValue,
    };
  }
  return state;
};
